module.exports = __webpack_public_path__ + "static/henho7-2fdac63cf30fa20336ea73dce0f5f21d.jpg";